import { CURRENT_META_VERSION, EditUserInfoRequest, USER_META_VERSION_240531, UserMeta } from "@services/editUser"
import useApiRequests from "@services/http/useApiRequest";
import { RootState } from "@store";
import { setMeta } from "@store/me/actions";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";


const useMyMeta = () => {
  const {enqueue} = useApiRequests();
  const meta_ = useSelector((root: RootState) => {
    const m = (root.me.meta ?? {Version: CURRENT_META_VERSION}) as UserMeta;
    if (m.Version === undefined) m.Version = USER_META_VERSION_240531;
    return m;
  });
  const dispatch = useDispatch();

  const send_ = useCallback(async (m: UserMeta) => {
    const r = await enqueue(new EditUserInfoRequest({meta: JSON.stringify(m)}));
    if (!r) return;
    dispatch(setMeta(m));
  }, [enqueue]);
  
  return {
    getLocationBuildingsOrder(loc: string): string[] { return meta_.LocationBuildingsOrder?.[loc] ?? [] },
    setLocationBuildingsOrder(loc: string, ord: string[]) {
      send_({...meta_, LocationBuildingsOrder: {...meta_.LocationBuildingsOrder, [loc]: ord}});
    }
  };
}

export default useMyMeta;